import { render, staticRenderFns } from "./CardHeadInfo.vue?vue&type=template&id=158ec5a0&scoped=true&"
import script from "./CardHeadInfo.vue?vue&type=script&lang=js&"
export * from "./CardHeadInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ec5a0",
  null
  
)

export default component.exports